
require('../sass/tipsReset.scss');
require('../sass/orderClauseTip.scss');
require('../sass/priceDetailTip.scss');
require('../sass/roomInfoTip.scss');


const
	Util 				= require('../../../common/util.js'),
	tipShowAndHide 		= Util.tipShowAndHide,
	roomInfoTipTmpl 	= require('../templates/roomInfoTipTmpl.ejs'),
	priceDetailTipTmpl 	= require('../templates/priceDetailTipTmpl.ejs'),
	orderClauseTipTmpl 	= require('../templates/orderClauseTipTmpl.ejs'),
	multiBreakfastDetailTipTmpl	= require('../templates/multiBreakfastDetailTipTmpl.ejs'),


	// 为预定条款 td 设置数据项
	setDataForOrderClauseTd = function(orderClauseTd, pList){
		var
			dataObj = {},
			clauses = [];

		for (var i = 0; i < pList.length; i++) {
			var reserveShowArr = pList[i].reserveShow.split(/[|;]/);
			for (var j = 0; j < reserveShowArr.length; j++) {
				var o = reserveShowArr[j];
				~o.indexOf('限住') ? dataObj['限制晚数'] = o :
				~o.indexOf('提前') ? dataObj['提前预订'] = o :
				~o.indexOf('至少连住') ? dataObj['至少连住'] = o :
				~o.indexOf('最大连住') ? dataObj['最大连住'] = o :
				~o.indexOf('连住') ? dataObj['连住多晚'] = o :
				~o.indexOf('时间') ? dataObj['限时预订'] = o :
				~o.indexOf('间数') ? dataObj['限制间数'] = o :
									dataObj['无预订条款'] = o;
			}
		}

		for(key in dataObj){
			if( key !== '无预订条款' )		clauses.push({name: key, tip: dataObj[key]});
		}

		orderClauseTd[0].clauses = clauses;

		clauses.length === 0 ? orderClauseTd.html('无预订条款').removeClass('hp-order-clause') :
		clauses.length === 1 ? orderClauseTd.html(clauses[0].name) :
							   orderClauseTd.html('复合条款');
	},

	// 查询房型信息，并将数据设置到相对应的 dom 上
	setDataForRoomTypeTd = function(roomTypeTd){

		$(roomTypeTd).on('mouseover', function(){
			var _this = $(this)
			var hotelId = _this.attr("hotelid")
			var suppId = _this.attr("supplierid")
			var roomId = _this.attr("roomid")
			var roomInfo = window.roomInfoArr[hotelId + '_' + suppId + '_' + roomId]

			if (roomInfo) {
				// 如果 state 里面已经存有该房型信息，则直接显示
				var msg = roomInfoTipTmpl(roomInfo);
				tipShowAndHide(_this, msg, {area: '245px'});
			} else {
				var params = {
					hotelId: hotelId,
					suppId: suppId,
					roomId: roomId
				};

				$.post("/hotel/roomInfo.do", params, function(res){
					if( res.success && res.content ){
						window.roomInfoArr[hotelId + '_' + suppId + '_' + roomId] = res.content
						_this.trigger('mouseover')
					}
				}, 'noAnimation');
			}

		})
	},

	// 初始化小礼包的 tips 显示
	initMarketingInfoTips = function(marketingTd){
		marketingTd.on('mouseover', function(){
			var msg = decodeURIComponent( marketingTd.attr('data-tip') );
			tipShowAndHide($(this), msg);
		})
	}

	// 预定条款 tips 的显示
	initOrderClauseTips = function(orderClauseTd){
		$(orderClauseTd).on('mouseover', function(){
			if(this.clauses.length){
				var msg = orderClauseTipTmpl({clauses: this.clauses})
				tipShowAndHide($(this), msg);	//, {area: '260px'}
			}
		});
	},

	// 初始化价格的 tips
	initHotelPriceTips = function(hotelPriceTd, pList){

		var isTimeLimitConfirSupplier = hotelPriceTd.closest('tr').find('.hp-store-status').text().indexOf('60秒确认') !== -1;
		var roomNum = $('.s-i-room-num').attr('data-value')

		hotelPriceTd.on('mouseover', function(){

			for (var i = 0; i < pList.length; i++) {
				var o = pList[i];

				// 设置房态显示    0：剩余库存  1畅订  2：待查  3：满房 5不可超售
				if( o.status === 3 ){
					o.statusText = '<span class="red">满房</span>';
				}else if( o.status === 2 || o.status === 6){
					let showText = $(this).closest('tr').find('.hp-store-status').text()
					// this.textContent

					o.statusText =
						~showText.indexOf('剩余')
							? '<span class="green">剩' + roomNum + '</span>'
							: '<span class="purple">待查</span>';
				}else if( o.status === 0 || o.status === 5 ){
					o.statusText =
						isTimeLimitConfirSupplier
							? '<span class="blue">60秒确认</span>'
							: ( (o.stock - o.sellStock < 1) ? '<span class="red">满房</span>' : '<span class="green">剩' + (o.stock - o.sellStock) + '</span>' );
				}else if( o.status === 1 ){
					o.statusText =
						isTimeLimitConfirSupplier
							? '<span class="blue">60秒确认</span>'
							: '<span class="green">畅订</span>';
				}
			}

			var msg = priceDetailTipTmpl({list: pList});

			tipShowAndHide($(this), msg, {area: '300px'});
		})
	},

	// 初始化多种早餐类型的 tips
	initMultiBreakfastTips = function(multiBreakfastTd, pList){
		multiBreakfastTd.on('mouseover', function(){
			var msg = multiBreakfastDetailTipTmpl({list: pList});
			tipShowAndHide($(this), msg, {area: '200px'});
		})
	},

	// 初始化取消条款的 tips
	initCancellationTips = function(cancellationTd, pList){
		cancellationTd.on('mouseover', function(){
			var _this = $(this),
				msg = _this.attr('data-tip');

			tipShowAndHide($(this), msg);
		})
  },
  // 初始化禁售OTA的 tips
	initSuppOtaChannelTips = function(suppOtaChannelTd, pList){
		suppOtaChannelTd.on('mouseover', function(){
			var _this = $(this),
				msg = _this.attr('data-tip');

			tipShowAndHide($(this), msg);
		})
	},

	// 初始化包含多种早餐类型的预定按钮
	initMultiBreakfastBookClick = function(td){
		td.on('click', function(e){
			if($(td).hasClass('disabled'))	return;

			e.preventDefault()
			var that = $(this)

			confirm('该价格包含多种早餐类型，是否预订？', function(e){
				$('.layui-layer-btn0').attr('href', that.attr('href'))
				$('.layui-layer-btn0').attr('target', '_blank')
				layer.closeAll()
			})
		})
	},

	// 初始化所有 tips
	initTips = function(_table){

		var trs = _table.find('tbody .hotel-price-tr');
		if(!window.roomInfoArr){
			window.roomInfoArr = {}
		}

		for (var i = 0; i < trs.length; i++) {
			var tr = $(trs[i]),
				pList = window.JSON.parse( tr.find('.nightlyPriceList').html() ),
				marketingTd = tr.find('.marketing-icon'),
				orderClauseTd = tr.find('.hp-order-clause'),
        cancellationTd = tr.find('.hp-cancel-clause'),
        suppOtaChannelTd = tr.find('.supp-ota'),
				multiBreakfastTd = tr.find('.multi-breakfast'),
				hotelPriceTd = tr.find('.hp-currency'),
				roomTypeTd = tr.find('.first-td').find('.hp-roomName'),
        roomStatusTd = tr.find('.hp-store-status');

			setDataForOrderClauseTd(orderClauseTd, pList);
			setDataForRoomTypeTd(roomTypeTd);

			initMarketingInfoTips(marketingTd);
			initOrderClauseTips(orderClauseTd, pList);
			initCancellationTips(cancellationTd, pList);
			initSuppOtaChannelTips(suppOtaChannelTd, pList);
			initHotelPriceTips(hotelPriceTd, pList);
			initHotelPriceTips(roomStatusTd, pList);	// 房态 tip 和价格详情用同一个 tip

			if(multiBreakfastTd.length){
				initMultiBreakfastTips(multiBreakfastTd, pList)
				initMultiBreakfastBookClick(tr.find('.hp-order-btn'))
			}
		}
	};



// 酒店价格列表的所有 tips 相关js
module.exports = {
    initTips: initTips
}



// WEBPACK FOOTER //
// ./src/common/hotelPriceUtil/modules/hotelPriceTableTips.js